import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { AppConfigService } from './app-config.service';
import { BehaviorSubject } from 'rxjs';
import { AppInsightsService } from './app-insights.service';
import { LoginService } from './login-action/login.service';

@Injectable({
  providedIn: 'root'
})
export class StudentSelectedBroadcastService {

  private hubConnection: signalR.HubConnection | undefined;
  private messageSource = new BehaviorSubject<any>(null);
  public messageReceived$ = this.messageSource.asObservable();

  constructor(private appConfigService: AppConfigService, private appInsightsService: AppInsightsService,
      private loginService: LoginService) { }


  public startConnection = async () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.appConfigService.config?.apiConfig?.basePath}/smshub`,
        {
          accessTokenFactory: () => this.loginService.getMicrosoftAccessToken()
        }
      )
      .withAutomaticReconnect([0, 3000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Debug)
      .build();

    this.hubConnection.onclose(error => {
      if (error) {
        this.appInsightsService.logException(error);
      }
    });
    await this.startHubConnection();

    this.hubConnection.onclose(() => {
      setTimeout(() => this.startConnection, 3000);
    });
  }

  public addInboundSmsReceivedListener = () => {
    this.registerHandlers(); // Initial registration
  };

  private registerHandlers = () => {
    this.hubConnection?.on('ReceiveMessage', (message) => {
      this.appInsightsService.logTrace(`NewSMSReceived ${JSON.stringify(message)}`)
      this.messageSource.next(message);
    });
  };

  private async startHubConnection() {
    await this.hubConnection?.start()
      .then(() => {
        this.appInsightsService.logTrace(`ConnectionStarted`);
        this.registerHandlers();
      })
      .catch(err => this.appInsightsService.logException(err));
  }

  public stopConnection(): void {
    if (this.hubConnection) {
      this.hubConnection.stop()
        .then(() => this.appInsightsService.logTrace(`ConnectionStopped`))
        .catch(err => this.appInsightsService.logException(err))
    }
  }
}
